"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogName = void 0;
const react_1 = require("@apollo/client/react");
const gql_1 = require("../gql");
const useCatalogName = ({ id }) => {
    const response = (0, react_1.useQuery)(gql_1.GET_CATALOG_NAME_BY_ID, { variables: { id }, skip: !id, fetchPolicy: 'cache-first' });
    return response;
};
exports.useCatalogName = useCatalogName;
